module.exports = __webpack_public_path__ + "95335d7ecbd0af6c4e32cc6c7281d24a.MP3";